export type WorksListItemLongTypesType =
  | 'Works::Onboarding::WorksListItemTypes::BackgroundIdentification'
  | 'Works::Onboarding::WorksListItemTypes::Immigration'
  | 'Works::Onboarding::WorksListItemTypes::License'
  | 'Works::Onboarding::WorksListItemTypes::Certification'
  | 'Works::Onboarding::WorksListItemTypes::Assessment'
  | 'Works::Onboarding::WorksListItemTypes::HealthDocument'
  | 'Works::Onboarding::WorksListItemTypes::OtherDocument';

export type WorksListItemShortTypesType =
  | 'assessment'
  | 'certification'
  | 'health_doc'
  | 'identification'
  | 'immigration'
  | 'license'
  | 'other_doc';

export type WorksListItemExpirationType =
  | 'NON_EXPIRABLE'
  | 'COMPLETION_DATE'
  | 'EXPIRATION_DATE';

export const worksListItemShortToLongTypeMap: {
  [key in WorksListItemShortTypesType]: WorksListItemLongTypesType;
} = {
  identification:
    'Works::Onboarding::WorksListItemTypes::BackgroundIdentification',
  immigration: 'Works::Onboarding::WorksListItemTypes::Immigration',
  license: 'Works::Onboarding::WorksListItemTypes::License',
  certification: 'Works::Onboarding::WorksListItemTypes::Certification',
  assessment: 'Works::Onboarding::WorksListItemTypes::Assessment',
  health_doc: 'Works::Onboarding::WorksListItemTypes::HealthDocument',
  other_doc: 'Works::Onboarding::WorksListItemTypes::OtherDocument',
};

export const worksListItemLongToShortTypeMap: {
  [key in WorksListItemLongTypesType]: WorksListItemShortTypesType;
} = {
  'Works::Onboarding::WorksListItemTypes::BackgroundIdentification':
    'identification',
  'Works::Onboarding::WorksListItemTypes::Immigration': 'immigration',
  'Works::Onboarding::WorksListItemTypes::License': 'license',
  'Works::Onboarding::WorksListItemTypes::Certification': 'certification',
  'Works::Onboarding::WorksListItemTypes::Assessment': 'assessment',
  'Works::Onboarding::WorksListItemTypes::HealthDocument': 'health_doc',
  'Works::Onboarding::WorksListItemTypes::OtherDocument': 'other_doc',
};

export const worksListItemExpirationTitles: {
  [key in WorksListItemExpirationType]: string;
} = {
  NON_EXPIRABLE: 'Non Expirable',
  COMPLETION_DATE: 'Completion Date',
  EXPIRATION_DATE: 'Expiration Date',
};
